import { SPSideBar } from '@group-link-one/gl-ui/sonarprint';
import React, { cloneElement } from 'react';
import S from './Main.template.style';
import type { ISPMainTemplate } from './types/Main.template.types';

export const MainTemplate: React.FC<ISPMainTemplate> = ({
  id,
  children,
  sidebarOptions,
}: ISPMainTemplate) => {
  return (
    <S.MainContainer id={id}>
      <SPSideBar {...sidebarOptions} />
      <S.SidebarSpacer />

      {cloneElement(children as React.ReactElement<Record<string, unknown>>, {
        sidebarOptions,
      })}
    </S.MainContainer>
  );
};
